const floatingRoot = document.querySelector('[data-house-of-aarvi-floating-actions]');

if (floatingRoot) {
  const reviewsTrigger = floatingRoot.querySelector('[data-house-of-aarvi-reviews-trigger]');
  const reviewsDialog = floatingRoot.querySelector('#house-of-aarvi-reviews-dialog');
  const reviewsClose = floatingRoot.querySelector('[data-house-of-aarvi-reviews-close]');
  const reviewsList = floatingRoot.querySelector('[data-house-of-aarvi-reviews-list]');
  const reviewsSort = floatingRoot.querySelector('[data-house-of-aarvi-reviews-sort]');
  const reviewsEmpty = floatingRoot.querySelector('[data-house-of-aarvi-reviews-empty]');
  let reviewItems = [];
  let previousReviewFocus;

  const getReviews = (detail) => {
    if (Array.isArray(detail)) return detail;
    if (Array.isArray(detail?.reviews)) return detail.reviews;
    return [];
  };

  const isSafeImageUrl = (value) => {
    if (!value) return false;

    try {
      const url = new URL(value, window.location.origin);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
      return false;
    }
  };

  const renderReviewCard = (review) => {
    const card = document.createElement('article');
    card.className = 'house-of-aarvi-review-card';
    card.setAttribute('role', 'listitem');

    const identity = document.createElement('div');
    identity.className = 'house-of-aarvi-review-card__identity';

    if (isSafeImageUrl(review.avatar)) {
      const avatarImage = document.createElement('img');
      avatarImage.className = 'house-of-aarvi-review-card__avatar';
      avatarImage.src = review.avatar;
      avatarImage.alt = '';
      avatarImage.loading = 'lazy';
      identity.append(avatarImage);
    } else {
      const avatar = document.createElement('span');
      avatar.className = 'house-of-aarvi-review-card__avatar';
      avatar.textContent = (review.name || '?').trim().charAt(0).toUpperCase() || '?';
      avatar.setAttribute('aria-hidden', 'true');
      identity.append(avatar);
    }

    const name = document.createElement('div');
    name.className = 'house-of-aarvi-review-card__name';
    name.textContent = review.name || 'Customer';

    if (String(review.countryCode || '').toUpperCase() === 'IN') {
      const flag = document.createElement('span');
      flag.className = 'house-of-aarvi-review-card__flag';
      flag.textContent = '🇮🇳';
      flag.setAttribute('aria-label', 'India');
      name.append(flag);
    }

    if (review.verified === true) {
      const verified = document.createElement('span');
      verified.className = 'house-of-aarvi-review-card__verified';
      verified.textContent = 'Verified';
      name.append(verified);
    }

    identity.append(name);
    card.append(identity);

    const rating = Number(review.rating);
    if (Number.isFinite(rating) && rating > 0) {
      const ratingElement = document.createElement('div');
      ratingElement.className = 'house-of-aarvi-review-card__rating';
      const roundedRating = Math.max(0, Math.min(5, Math.round(rating)));
      ratingElement.textContent = `${'★'.repeat(roundedRating)}${'☆'.repeat(5 - roundedRating)}`;
      ratingElement.setAttribute('aria-label', `${roundedRating} out of 5 stars`);
      card.append(ratingElement);
    }

    const text = document.createElement('p');
    text.className = 'house-of-aarvi-review-card__text';
    text.textContent = review.text || '';
    card.append(text);

    const product = review.product || {};
    if (product.title || product.reference || isSafeImageUrl(product.image)) {
      const productReference = document.createElement('div');
      productReference.className = 'house-of-aarvi-review-card__product';

      if (isSafeImageUrl(product.image)) {
        const productImage = document.createElement('img');
        productImage.src = product.image;
        productImage.alt = product.title || '';
        productImage.loading = 'lazy';
        productReference.append(productImage);
      }

      const productTitle = document.createElement('span');
      productTitle.textContent = product.title || product.reference || '';
      productReference.append(productTitle);
      card.append(productReference);
    }

    return card;
  };

  const renderReviews = () => {
    if (!reviewsList) return;

    const sortedReviews = [...reviewItems].sort((first, second) => {
      if (reviewsSort?.value === 'highest') {
        return Number(second.rating || 0) - Number(first.rating || 0);
      }

      return new Date(second.date || 0).getTime() - new Date(first.date || 0).getTime();
    });

    reviewsList.replaceChildren();

    if (sortedReviews.length === 0) {
      if (reviewsEmpty) {
        reviewsList.append(reviewsEmpty);
      }
      return;
    }

    sortedReviews.forEach((review) => reviewsList.append(renderReviewCard(review)));
  };

  const setReviews = (detail) => {
    reviewItems = getReviews(detail).filter((review) => review && typeof review === 'object');
    renderReviews();
  };

  if (reviewsDialog && reviewsTrigger) {
    reviewsTrigger.addEventListener('click', () => {
      previousReviewFocus = document.activeElement;
      reviewsDialog.showDialog();
    });

    reviewsDialog.addEventListener('dialog:open', () => {
      reviewsClose?.focus();
    });

    reviewsDialog.addEventListener('dialog:close', () => {
      if (previousReviewFocus instanceof HTMLElement) previousReviewFocus.focus();
    });

    reviewsClose?.addEventListener('click', () => {
      reviewsDialog.closeDialog();
    });

    reviewsSort?.addEventListener('change', renderReviews);
    renderReviews();
  }

  window.addEventListener('house-of-aarvi:reviews-ready', (event) => {
    setReviews(event.detail);
  });

  if (Array.isArray(window.HouseOfAarviReviews)) {
    setReviews(window.HouseOfAarviReviews);
  }

  const aiTrigger = floatingRoot.querySelector('[data-house-of-aarvi-ai-trigger]');
  const aiPanel = floatingRoot.querySelector('[data-house-of-aarvi-ai-panel]');
  const aiClose = floatingRoot.querySelector('[data-house-of-aarvi-ai-close]');
  const aiForm = floatingRoot.querySelector('[data-house-of-aarvi-ai-form]');
  const aiInput = floatingRoot.querySelector('[data-house-of-aarvi-ai-input]');
  const aiMessages = floatingRoot.querySelector('[data-house-of-aarvi-ai-messages]');
  const aiCart = floatingRoot.querySelector('[data-house-of-aarvi-ai-cart]');
  const aiMenu = floatingRoot.querySelector('[data-house-of-aarvi-ai-menu]');
  let previousAiFocus;
  let products = [];

  const productDataElement = floatingRoot.querySelector('[data-house-of-aarvi-ai-products]');
  if (productDataElement) {
    try {
      products = JSON.parse(productDataElement.textContent || '[]');
      products = products.filter((product) => product && product.title).filter((product, index, list) => {
        return list.findIndex((candidate) => candidate.url === product.url) === index;
      });
    } catch {
      products = [];
    }
  }

  const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

  const addAssistantMessage = (text, product) => {
    if (!aiMessages) return;

    const message = document.createElement('div');
    message.className = 'house-of-aarvi-ai-message house-of-aarvi-ai-message--assistant';

    if (product) {
      const title = document.createElement('a');
      title.href = product.url;
      title.textContent = product.title;
      title.target = '_self';
      message.append(document.createTextNode(text), title);
    } else {
      message.textContent = text;
    }

    aiMessages.append(message);
    aiMessages.scrollTop = aiMessages.scrollHeight;
  };

  const addUserMessage = (text) => {
    if (!aiMessages) return;
    const message = document.createElement('div');
    message.className = 'house-of-aarvi-ai-message house-of-aarvi-ai-message--user';
    message.textContent = text;
    aiMessages.append(message);
    aiMessages.scrollTop = aiMessages.scrollHeight;
  };

  const findProduct = (query) => {
    const normalizedQuery = normalize(query);
    const exactMatch = products.find((product) => normalizedQuery.includes(normalize(product.title)));
    if (exactMatch) return exactMatch;

    const queryTokens = normalizedQuery.split(' ').filter((token) => token.length > 2);
    return products.find((product) => {
      const productTokens = normalize(product.title).split(' ');
      return queryTokens.some((token) => productTokens.includes(token));
    });
  };

  const answerQuestion = (query) => {
    const savingsQuestion = /save|saving|savings|discount|compare|off/.test(normalize(query));
    const product = findProduct(query) || (savingsQuestion ? products.find((item) => item.hasSavings) : undefined);

    if (savingsQuestion) {
      if (!product) {
        return {
          text: 'I can calculate savings when an AI collection is configured and the product has a Shopify compare-at price.'
        };
      }

      if (!product.hasSavings) {
        return {
          text: `I could not calculate a discount for ${product.title} because this product does not have a compare-at price.`
        };
      }

      return {
        text: `You save ${product.savingsFormatted} on `,
        product,
        suffix: `, from ${product.compareAtPriceFormatted} to ${product.priceFormatted}.`
      };
    }

    if (product) {
      return {
        text: 'You can view ',
        product,
        suffix: ` for its current Shopify price and availability.`
      };
    }

    return {
      text: 'The live AI service is not connected yet. You can browse the collection shortcuts above or chat with us on WhatsApp.'
    };
  };

  const respondToQuestion = (query) => {
    const response = answerQuestion(query);
    if (response.product && response.suffix) {
      addAssistantMessage(response.text, response.product);
      const lastMessage = aiMessages?.lastElementChild;
      if (lastMessage) lastMessage.append(document.createTextNode(response.suffix));
      return;
    }

    addAssistantMessage(response.text, response.product);
  };

  const openAiPanel = () => {
    if (!aiPanel || !aiTrigger) return;
    previousAiFocus = document.activeElement;
    aiPanel.hidden = false;
    aiPanel.setAttribute('aria-hidden', 'false');
    aiTrigger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => aiInput?.focus());
  };

  const closeAiPanel = () => {
    if (!aiPanel || !aiTrigger) return;
    aiPanel.hidden = true;
    aiPanel.setAttribute('aria-hidden', 'true');
    aiTrigger.setAttribute('aria-expanded', 'false');
    if (previousAiFocus instanceof HTMLElement) previousAiFocus.focus();
  };

  if (aiTrigger && aiPanel) {
    aiTrigger.addEventListener('click', () => {
      if (aiPanel.hidden) openAiPanel();
      else closeAiPanel();
    });

    aiClose?.addEventListener('click', closeAiPanel);

    aiForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      const query = aiInput?.value.trim();
      if (!query) return;
      addUserMessage(query);
      if (aiInput) aiInput.value = '';
      respondToQuestion(query);
    });

    aiCart?.addEventListener('click', () => {
      window.location.href = aiPanel.dataset.cartUrl || '/cart';
    });

    aiMenu?.addEventListener('click', () => {
      addAssistantMessage('This assistant currently uses live Shopify product data for pricing questions. An external AI connection has not been configured.');
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (aiPanel && !aiPanel.hidden) closeAiPanel();
  });
}
